<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="editOrgOwnerDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Organization Owner</div
  >

  <form
    class="flex flex-col"
    [formGroup]="editOrgOwnerForm"
    (ngSubmit)="save()"
  >
    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="editOrgOwnerDialogEmailInput"
      type="email"
      class="form-input border-s3 focus:border-m600 mt-9 w-96 rounded"
      [ngClass]="{
        'border-r600':
          editOrgOwnerForm.controls['ownerEmail'].invalid &&
          editOrgOwnerForm.controls['ownerEmail'].touched
      }"
      formControlName="ownerEmail"
      placeholder="New Owner Email"
    />
    <m-validation
      [control]="editOrgOwnerForm.controls['ownerEmail']"
    ></m-validation>

    <p class="text-s1 text-base"
      >The new owner must be a registered Mprove user with a verified email
      address</p
    >

    <div class="mt-6">
      <button
        data-cy="editOrgOwnerDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="editOrgOwnerDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
